import Plural from 'components/utils/Formatters/Plural'
import config from 'constants/config'
import React from 'react'

interface Props {
  points: number
  abbreviated?: boolean
}

function FormatLoyaltyBonusPoints({ points, abbreviated }: Props) {
  if (abbreviated) {
    return <Plural
      singular={config.loyalty.bonusPointsUnitAbbreviation}
      count={points}
      withCount
    />
  }
  return <Plural
    singular={config.loyalty.bonusPointsUnit}
    count={points}
    withCount
  />
}

export default FormatLoyaltyBonusPoints
